export default __webpack_public_path__ + "static/media/LogoWithTextBlock.8e994548.png";